module.exports = __webpack_public_path__ + "static/media/celeron-350x210.b8e50a5b.jpg";